import React from "react";

export const LOC_STATUS = {
  devis_brouillon: "Devis en préparation", devis_envoye: "Devis envoyé", confirmee: "Confirmée", preparee: "Matériel préparé", en_cours: "Location en cours",
  retournee: "Retournée", controle: "Contrôle en cours", cloturee: "Clôturée", incident: "Incident", annulee: "Annulée",
};
export const DEPOSIT_STATUS = {
  a_obtenir: "À obtenir", en_attente: "Carte enregistrée — empreinte à venir", garantie_obtenue: "Garantie obtenue", location_en_cours: "Location en cours",
  materiel_retourne: "Matériel retourné", controle_en_cours: "Contrôle en cours", liberable: "Caution libérable", liberee: "Libérée",
  incident: "Incident", retenue_a_traiter: "Retenue / encaissement à traiter", encaissee: "Encaissée",
};
export const GAME_STATUS = {
  brouillon: "Brouillon", envoye: "Envoyé au client", en_cours: "En cours", a_completer: "À compléter", complete: "Complété",
  valide_client: "Validé par le client", verrouille: "Verrouillé", pret: "Prêt pour animation", archive: "Archivé",
};

export const fmtEur = (v) => (v === null || v === undefined || v === "" ? "—" : `${Number(v).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €`);
export const fmtDate = (v) => (v ? new Date(v.length <= 10 ? `${v}T12:00:00` : v).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "—");
export const fmtDateTime = (v) => (v ? new Date(v).toLocaleString("fr-FR", { timeZone: "Europe/Paris", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export function Pill({ children, tone = "gold", testid }) {
  const tones = {
    gold: "text-[#DCB457] border-[#DCB457]/40", ok: "text-emerald-300 border-emerald-400/40", warn: "text-amber-200 border-amber-300/40",
    danger: "text-red-300 border-red-400/40", muted: "text-white/55 border-white/15", info: "text-sky-200 border-sky-300/30",
  };
  return <span data-testid={testid} className={`inline-flex items-center text-[10px] uppercase tracking-[0.18em] border px-2 py-1 whitespace-nowrap ${tones[tone] || tones.gold}`}>{children}</span>;
}

export function Field({ label, children, className = "" }) {
  return (
    <label className={`block ${className}`}>
      <span className="text-[10px] uppercase tracking-[0.2em] text-white/45">{label}</span>
      <div className="mt-1">{children}</div>
    </label>
  );
}

export function Panel({ title, action, children, testid, className = "" }) {
  return (
    <section className={`card-luxe p-5 md:p-6 ${className}`} data-testid={testid}>
      {(title || action) && (
        <div className="flex items-center justify-between gap-3 mb-4">
          {title && <h2 className="font-serif-luxe text-xl">{title}</h2>}
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function AlertList({ alerts = [], testid }) {
  if (!alerts.length) return <p className="text-sm text-white/45 italic">Aucune alerte.</p>;
  const tone = { danger: "border-red-400/40 text-red-200", warn: "border-amber-300/40 text-amber-100", ok: "border-emerald-400/30 text-emerald-200", info: "border-white/10 text-white/75" };
  return (
    <ul className="space-y-2" data-testid={testid}>
      {alerts.map((a, i) => (
        <li key={i}><a href={a.link} className={`block border-l-2 pl-3 py-1.5 text-sm hover:bg-white/[0.03] transition-colors ${tone[a.level] || tone.info}`}>{a.text}</a></li>
      ))}
    </ul>
  );
}

export const listToText = (l) => (l || []).join("\n");
export const textToList = (t) => (t || "").split("\n").map((s) => s.trim()).filter(Boolean);
